import React from 'react';
import PropTypes from 'prop-types';

const ProductSwatchSizesSelection = ({
  swatches,
  selectedItemSize,
  selectedItemUnits,
  label = '',
  separator = ':',
}) => (
  <div className="product-swatch-selection">
    <span className="product-swatch-selection__value">
      {swatches.length} {label}{separator}
    </span>
    <span className="product-swatch-selection__name">
      {selectedItemSize} {selectedItemUnits}
    </span>
  </div>
);

ProductSwatchSizesSelection.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    // TODO: define proper shape structure for swatch object
    units: PropTypes.string,
    sku: PropTypes.string,
  })).isRequired,
  selectedItemSize: PropTypes.string,
  selectedItemUnits: PropTypes.string,
  label: PropTypes.string,
  separator: PropTypes.string,
};

export default ProductSwatchSizesSelection;
